export const environment = {
  production: false,
  Okta: {
    issuer: 'https://ssodev.carecoordinationsystems.com/oauth2/default',
    clientId: '0oao1uydqjZapzH1L1d7',
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    postLogoutRedirectUri: window.location.origin + '/login',
    redirectUri: window.location.origin + '/login/callback',
  },
  apiAllowedOrigins: ['https://hb20apidev.healthbridge.care'],
  apiBaseUrl: 'https://hb20apidev.healthbridge.care/api/',
  apiEndpoints: {
    user: {
      signIn: 'User/RecordUserLogin',
      signOut: 'Login/Logout',
      menu: 'User/Menu',
      tabs: 'User/Tabs',
      appLogo: 'Branding/GetTopLeftImage.png',
      billing: {
        guideGenerateInvoice: 'v2/GuideClaims/generateInvoice',
        guideReceiveInvoices: 'v2/GuideClaims/receiveInvoices',
        guideRemitInvoices: 'v2/GuideClaims/remitInvoices',
        guideParticipants: 'v2/GuideClaims/participants',
        guideInvoices: 'v2/GuideClaims/invoices',
        guideReceived: 'v2/GuideClaims/received',
        guideRemitted: 'v2/GuideClaims/remitted',
      },
      clients: {
        caseload: 'v2/Caseload',
        client: 'Client',
        contactEvents: 'ContactEvent/ForClient',
        contactEvent: 'ContactEvent/GetById',
        contactEventOptions: 'ContactEvent/ModalOptions',
        contactEventNotes: 'CentralNotes/ContactEvent',
        CentralNotes: 'CentralNotes/AllForClient',
        documents: 'ClientDocuments/ListForClient',
        uploadDocument: 'ClientDocuments/UploadNewDocument',
        deleteDocument: 'ClientDocuments',
        dowloadDocument: 'ClientDocuments/ViewAsUrl',
        viewToken: 'ClientDocuments/ViewToken',
        timeline: 'Timeline',
        healthwise: {
          launchUrl: 'Healthwise/GetLaunchData',
          endCallUrl: 'Healthwise/EndCall',
          activity: 'Healthwise/GetClientActivity',
          activityUpdate: 'Healthwise/GetClientActivityUpdate',
          print: 'Healthwise/Print',
        },
        diyahealth: {
          client: 'v2/DiyaHealth/client',
        },
      },
      profile: 'User/MyInfo',
      signer: 'UserProfile/SignerDetails',
      documentViewToken: 'User/NewDocViewToken',
      forms: {
        preview: 'v2/DynamicForm/preview',
        edit: 'v2/DynamicForm/edit',
        view: 'v2/DynamicForm/view',
        create: 'v2/DynamicForm/create',
        template: 'FormTemplate/FORM_THREE/ForHubAgency',
        values: 'FormInstance/Values',
        update: 'FormInstance/FORM_THREE/Update',
        save: 'v2/DynamicForm/save',
        centralNotes: 'CentralNotes',
      },
      admin: {
        api_restart: 'Admin/StopApp',
        api_clearAppCache: 'Admin/ClearAppCache',
        rebuild_userOktaGroups: 'User/RebuildOktaGroups',
        rebuild_allOktaGroups: 'Admin/RebuildAllUserOktaGroups',
        broadcast_message: 'Admin/BroadcastTestServerMessage',
      },
      filters: 'ClientCaseloadGrid/FilterInfo',
      messages: {
        inbox: 'Message/FullMailbox',
      },
      contactEvents: {
        all: 'v2/ContactEvents/All'
      }
    },
    client: {
      basicInfo: 'ClientInfo/BasicClientView',
      demographics: 'DemographicHeader',
      contactEvents: 'ContactEvent/ForClient',
      clientForms: 'ClientForms',
      tasks: 'ClientInfo/Tasks',
      centralNotes: 'CentralNotes/ForClient',
      centralNotesForms: 'CentralNotes/ClientsForms',
      updateCentralNotes: 'CentralNotes/UpdateNote',
      deleteCentralNotes: 'CentralNotes',
      timeline: 'ClientInfo/Timeline',
      documents: 'ClientDocs',
      uploadDocuments: 'ClientDocs/UploadFile',
      viewDocument: 'PublicClientDocs/ViewFile',
      downloadDocument: 'PublicClientDocs/DownloadFile',
    },
    forms: {
      master: '',
      formFields: '',
      formValues: '',
    },
    configuration: {
      hub: {
        documentsTree: 'HubDocuments/GetTree',
      }
    },
    version: 'Admin/GitVersion',
  }
};
